import React, { useState } from 'react';
import PropTypes from 'prop-types';

// Tabs that take content for each
export const TabContents = ({ className, dataTabs, defaultTab }) => {
  const [visibleTab, setVisibleTab] = useState(defaultTab)

  return (
    <div className={`mz-tabs ${className}`}>
      <div className="mz-tabs-menu">
        <div className="mz-tabs-menu-container">
          <div className="mz-tabs-menu-inner">
            {
              dataTabs.map((item, index) =>
                <a
                  onClick={() => setVisibleTab(item.id)}
                  key={item.id}
                  className={`mz-tabs-tab interactive ${visibleTab === item.id ? 'active' : ''}`}
                  data-tab_target={index}
                  data-tab-name={item.tabTitle}
                >
                  {item.tabTitle}
                </a>
              )
            }
          </div>
        </div>
        <div className="mz-tabs-menu--left"><i className="mz-svg mz-svg--grey mz-svg-chevron mz-svg--rotate180"></i></div>
        <div className="mz-tabs-menu--right"><i className="mz-svg mz-svg--grey mz-svg-chevron"></i></div>
      </div>

      <div className="mz-tabs-container">
        {
          dataTabs.map((item, index) => (
            <div key={item.id} className={`mz-container ${visibleTab === item.id ? 'active' : ''}`} data-tab_target={index} >
              {item.tabContent}
            </div>
          ))
        }
      </div>
    </div>
  );
}

TabContents.propTypes = {
  dataTabs: PropTypes.array.isRequired,
  defaultTab: PropTypes.string,
  className: PropTypes.string,
}

TabContents.defaultProps = {
  dataTabs: [],
  defaultTab: '',
  className: ''
}